import axiosInstance from './axios';

export const uploadService = {
  uploadMedia: async (file, type, folder = 'products') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('folder', folder);

    const response = await axiosInstance.post('/upload/media', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  },

  deleteMedia: async (url) => {
    const response = await axiosInstance.post('/delete/media', { url });
    return response.data;
  },
};
